/* eslint-disable no-empty-pattern */
/* eslint no-param-reassign: 0 */
import { VideoService } from '../services/video.service';

const videosState = {
  videos: [],
  state: '',
  conf: {
    direction: 'desc',
    sort: 'created',
    page: 1,
    per_page: 20,
    max_page: 1,
  },
};

const mutations = {
  /**
   * Set videos sate
   * @param {Object} state
   * @param {String} type
   */
  setState(state, type) {
    state.state = type;
  },
  /**
   * Set videos list
   * @param {Object} state
   * @param {Array}  videos
   */
  setList(state, videos) {
    state.videos = videos;
  },
  /**
   * Set the config
   * @param {Object} state
   * @param {Object} conf
   */
  setConf(state, conf) {
    state.conf = conf;
  },
};

const getters = {
  /**
   * Get the list of videos
   * @return {Array}
   */
  list: state => state.videos,
  /**
   * Get the current state
   * @return {String}
   */
  state: state => state.state,
  /**
   * Get the current config
   * @return {Object}
   */
  conf: state => state.conf,
  /**
   * Get a compiled list of pagination
   * @return {Object}
   */
  pagination: state => ({ page: state.conf.page, per_page: state.conf.per_page, max_page: state.conf.max_page }),
};

const actions = {
  /**
   * Get videos
   * @param {Object}    obj - Object
   * @param {Function}  obj.commit
   * @param {Object}    obj.state
   * @param {Function}  obj.dispatch
   * @param {Object}    params
   * @return {Boolean}
   */
  getVideos: async ({ commit, state, dispatch }, params) => {
    let payload;

    if (!params.skipConf) {
      payload = JSON.parse(JSON.stringify(state.conf));
      delete payload.max_page;
    } else {
      payload = JSON.parse(JSON.stringify(params));
      delete payload.skipConf;
    }
    if (params.skipState) {
      delete payload.skipState;
    }

    try {
      if (!params.skipLoading) {
        commit('setState', 'loading');
      }
      const videos = await VideoService.getVideos(payload);
      if (!params.skipState) {
        commit('setList', videos.videos);
      }
      commit('setState', '');
      if (!params.skipConf) {
        dispatch('updateConf', { page: videos.pagination.current_page, max_page: videos.pagination.max_page });
      }
      return videos;
    } catch (e) {
      return false;
    }
  },
  /**
   * Update config
   * @param {Object}    obj - Object
   * @param {Function}  obj.commit
   * @param {Object}    obj.state
   * @param {Object}    options
   */
  updateConf: ({ commit, state }, options) => {
    const conf = Object.assign(JSON.parse(JSON.stringify(state.conf)), options);
    commit('setConf', conf);
  },
};

export default {
  namespaced: true,
  state: videosState,
  mutations,
  getters,
  actions,
};
